import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewChild, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { DialogLayoutComponent } from "@obg/mat.ui.core";
import { CommonState, PaymentSettings } from "@obg/ngx.common";
import { RouteAction } from "@obg/ngx.router";

@Component({
	selector: "obg-m-kyc-method-selection-dialog",
	templateUrl: "./kyc-method-selection-dialog.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class KycMethodSelectionDialogContainer {
	@ViewChild("dialog") dialogLayout!: DialogLayoutComponent;
	@HostBinding("class.obg-m-kyc-method-selection-dialog") hostClass = true;

	@Input() dialogId: string | undefined;

	constructor(private store: Store<CommonState>) {}

	close(params?: PaymentSettings) {
		this.store.dispatch(
			RouteAction.updateQueryParams({ rewardIdentifier: null, skipRewardClaim: null, siteTrackingId: null })
		);

		if (params?.redirect) {
			this.store.dispatch(RouteAction.navigate(params.redirect, undefined, { replaceUrl: true }));
			return;
		}

		this.returnToPreviousState();
	}

	private returnToPreviousState() {
		if (this.dialogLayout.isDialog) {
			this.dialogLayout.close();
			return;
		}

		return this.store.dispatch(RouteAction.back());
	}
}
